import { Card } from "primereact/card";
import { Skeleton } from "primereact/skeleton";
import { Tooltip } from "primereact/tooltip";

const Value = ({ value }: { value: any }) => (
  <div style={{ fontSize: "20px", fontWeight: "bold" }}>
    <p className="m-0">{value}</p>
  </div>
);
const Difference = ({ difference }: { difference: any}) => {
  let color = "inherit"; // Default color (gray)
  let displayValue: string | number = "";

  if (typeof difference === "number") {
    if (difference > 0) {
      color = "red";
    } else if (difference < 0) {
      color = "green";
    }
    if (difference === Infinity) {
      displayValue = "∞";
    } else if (difference === -Infinity) {
      displayValue = "-∞";
    } else {
      displayValue = `${difference.toFixed(0)}%`; // Display as percentage with no decimal places
    }
  } else {
    displayValue = difference;
  }
  return (
    <div style={{ fontSize: "12px", color }}>
      <p className="m-0">{displayValue}</p>
    </div>
  );
};

//TODO: Change AssetsTalbe
export const StatisticCard = ({
  header,
  id,
  index,
  value,
  tooltip,
  difference
  
}: {
  header: string;
  index: number;
  id: string;
  value: any;
  tooltip?: string;
  difference? : any

}) => {
  const targetID = `card-${id}`; // Create a unique ID for each card

  return (
    <div
    className="card"
    style={{
      flex: 1,
      margin:
        index === 0
          ? "20px 0px 0 0"
          : index === -1
          ? "20px 0 0 0"
          : "20px 0px 0 20px",
    }}
    
  >
    <Tooltip
      target={`#${targetID} .p-card-header`} // Target the specific card header using ID
      content={tooltip}
      position="top"
      style={{ maxWidth: "200px" }}  // Set max-width directly
      showDelay={250}
    />

    <Card
    id={targetID}
    className="custom-target-icon"
    header={header}
      style={{
        border: "1px solid #e9ecef",
        borderRadius: "5px",
        boxShadow: "0px 0px 2px rgba(0, 0, 0, 0.2)",
      }}
      data-pr-tooltip="No notifications"
      pt={{
        root: { style: { height: "85%" } },
        header: {
          style: {
            backgroundColor: "rgb(248 248 250)",
            textAlign: "center",
            borderBottom: "1px solid #e9ecef",
            fontSize: "1.4vh",
            padding: "5px",
          },
        },
        content: {
          style: {
            textAlign: "center",
            transform: "translateY(-20%)",
          },
        },
      }}
    >
      <Value value={value === 0 ? 0 : !value ? <Skeleton/>  : value} />
      <Difference difference={difference === 0 ? 0 : !difference ? ''  : difference} />
    </Card>
  </div>
  );
};